import { parseQueryString } from "app/provider-panel/utils/urls";
import { pick } from "lodash";
import { KNOWN_FILTERS } from "app/provider-panel/constants/filterTypes";
import { filtersMapper, pageParamsMapper } from "app/provider-panel/utils/index";
import { getProviderPanelPreferences } from "app/provider-panel/apis";

export const urlViewPreferences = () => {
  const queryParams = parseQueryString();
  const filterParams = pick(queryParams, KNOWN_FILTERS);
  const pageParams = pick(queryParams, ['page', 'perPage']);

  return {
    filters: {...(filterParams && filtersMapper.fromQueryParams(filterParams))},
    pageParams: {...pageParamsMapper.fromQueryParams(pageParams)}
  }
};

export const storedViewPreferences = async () => {
  const { filters: filterPreferences, viewSize } = await getProviderPanelPreferences();

  return {
    filters: {...(filterPreferences && filtersMapper.fromViewFilterPreferences(filterPreferences))},
    pageParams: {...(viewSize && {perPage: viewSize})}
  }
};
